module.exports = __webpack_public_path__ + "img/cliclhSh.2de951aa.png";